
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderAddressGrid extends Serenity.EntityGrid<ECommOrderAddressRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommOrderAddress'; }
        protected getDialogType() { return ECommOrderAddressDialog; }
        protected getIdProperty() { return ECommOrderAddressRow.idProperty; }
        protected getInsertPermission() { return ECommOrderAddressRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderAddressRow.localTextPrefix; }
        protected getService() { return ECommOrderAddressService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}